import Color from 'color'

/**
 *
 * @param config
 * @returns {{}}
 */
export default function (config) {

    const primaryColor = Color(config.primaryColor);
    const onPrimaryColor = Color(config.onPrimaryColor);
    const secondaryColor = Color(config.secondaryColor);
    const onSecondaryColor = Color(config.onSecondaryColor);
    const hotColor = config.hotColor;
    const onHotColor = config.onHotColor;

    return {
        primaryColor: primaryColor.string(),
        primaryColorAlpha: primaryColor.alpha(0.7).string(),
        primaryColorLight: primaryColor.lighten(0.4).string(),
        primaryColorDark: primaryColor.darken(0.4).string(),
        onPrimaryColor: onPrimaryColor.string(),
        onPrimaryColorAlpha: onPrimaryColor.alpha(0.2).string(),
        secondaryColor: secondaryColor.string(),
        secondaryColorAlpha: secondaryColor.alpha(0.7).string(),
        secondaryColorLight: secondaryColor.lighten(0.4).string(),
        secondaryColorDark: secondaryColor.darken(0.4).string(),
        onSecondaryColor: onSecondaryColor.string(),
        hotColor,
        onHotColor
    }
};